const axios = require('axios');
import { VueCookieNext } from 'vue-cookie-next'
let helpers = {};

helpers.callServer = function(type, group, url, body = {}){
  // Shouldn't be using any GET requests cause we can't send a body that includes the group/trust name
  if(type == 'GET'){
    return axios.get(url, { headers: { Authorization: `Bearer ${VueCookieNext.getCookie('token')}` } });
  } else if (type == 'POST'){
    return axios.post(url, { ...body, group: group }, { headers: { Authorization: `Bearer ${VueCookieNext.getCookie('token')}` } });
  }
}

export default helpers;
